import isDraftProduct from "./isDraftProduct";

export const findOmsId = () => {
  const url = typeof window !== 'undefined' ? window?.location?.href : '';
  let id;

  if (isDraftProduct) {
    id = url.match(/\?draftProductId=([0-9]+)\&?/i)[1];
  } else {
    const urlOmsId = url.match(/[0-9]{9}/g);
    const anchorSku = url.match(/\?omsid=([0-9]+)\&?/i);
    id = anchorSku ? anchorSku[1] : urlOmsId ? urlOmsId.length > 1 ? urlOmsId[1] : urlOmsId[0] : null;
  }

  return id;
}


const omsId = findOmsId();

export default omsId;
